import Immutable from 'immutable';
import {
  FLAG_GETTING_ADDRESSES,
  GET_ADDRESSES,
  CLEAR_ADDRESSES,
  GET_ADDRESS,
  CLEAR_ADDRESS,
  FLAG_ADDRESS_ACTIVITY,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_ADDRESSES:
      return state.setIn(['all', 'loading'], payload);
    case GET_ADDRESSES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ADDRESSES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case GET_ADDRESS:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ADDRESS:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_ADDRESS_ACTIVITY:
      // raising flag
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    default:
      return state;
  }
};
